// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__9F-ao","listbox":"Menu_listbox__mNGPM","body":"Menu_body__5Uldf","footer":"Menu_footer__1k-nN"};